const hr = {
  // ============================================================
  // COMMON — Zajedničko za cijelu aplikaciju
  // ============================================================
  common: {
    loading: 'Učitavanje...',
    error: 'Pogreška',
    save: 'Spremi',
    cancel: 'Odustani',
    delete: 'Obriši',
    edit: 'Uredi',
    create: 'Stvori',
    add: 'Dodaj',
    remove: 'Ukloni',
    close: 'Zatvori',
    confirm: 'Potvrdi',
    apply: 'Primijeni',
    reset: 'Poništi',
    search: 'Pretraži',
    filter: 'Filter',
    clear: 'Očisti',
    back: 'Natrag',
    next: 'Dalje',
    previous: 'Prethodni',
    submit: 'Pošalji',
    update: 'Ažuriraj',
    refresh: 'Osvježi',
    export: 'Izvezi',
    import: 'Uvezi',
    download: 'Preuzmi',
    upload: 'Učitaj',
    print: 'Ispiši',
    copy: 'Kopiraj',
    yes: 'Da',
    no: 'Ne',
    ok: 'U redu',
    done: 'Gotovo',
    select: 'Odaberi',
    selectAll: 'Odaberi sve',
    deselectAll: 'Poništi odabir',
    noResults: 'Nema rezultata',
    noData: 'Nema dostupnih podataka',
    required: 'Obavezno',
    optional: 'Neobavezno',
    actions: 'Radnje',
    details: 'Pojedinosti',
    overview: 'Pregled',
    summary: 'Sažetak',
    total: 'Ukupno',
    all: 'Sve',
    none: 'Ništa',
    name: 'Naziv',
    type: 'Vrsta',
    status: 'Stanje',
    date: 'Datum',
    time: 'Vrijeme',
    description: 'Opis',
    notes: 'Bilješke',
    comments: 'Komentari',
    category: 'Kategorija',
    priority: 'Prioritet',
    nation: 'Država',
    country: 'Država',
    email: 'E-pošta',
    phone: 'Telefon',
    address: 'Adresa',
    location: 'Lokacija',
    coordinates: 'Koordinate',
    latitude: 'Zemljopisna širina',
    longitude: 'Zemljopisna dužina',
    from: 'Od',
    to: 'Do',
    createdAt: 'Stvoreno',
    updatedAt: 'Ažurirano',
    createdBy: 'Stvorio',
    modifiedBy: 'Izmijenio',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    enabled: 'Omogućeno',
    disabled: 'Onemogućeno',
    showing: 'Prikazano',
    of: 'od',
    page: 'Stranica',
    perPage: 'po stranici',
    rows: 'redovi',
    items: 'stavke',
    results: 'rezultati',
    sortBy: 'Poredaj po',
    ascending: 'Uzlazno',
    descending: 'Silazno',
    viewAll: 'Prikaži sve',
    viewDetails: 'Prikaži pojedinosti',
    goBack: 'Vrati se',
    learnMore: 'Saznaj više',
    seeMore: 'Prikaži više',
    showMore: 'Prikaži više',
    showLess: 'Prikaži manje',
    expandAll: 'Proširi sve',
    collapseAll: 'Sažmi sve',
    copied: 'Kopirano!',
    saved: 'Spremljeno!',
    deleted: 'Obrisano!',
    updated: 'Ažurirano!',
    created: 'Stvoreno!',
    success: 'Uspjeh',
    warning: 'Upozorenje',
    info: 'Informacija',
    danger: 'Opasnost',
    unknown: 'Nepoznato',
    notAvailable: 'Nedostupno',
    never: 'Nikada',
    today: 'Danas',
    yesterday: 'Jučer',
    tomorrow: 'Sutra',
    now: 'Sada',
    ago: 'prije',
    justNow: 'upravo sada',
    minutesAgo: 'prije {{count}} min',
    hoursAgo: 'prije {{count}} h',
    daysAgo: 'prije {{count}} d',
    monthsAgo: 'prije {{count}} mj',
    id: 'ID',
    version: 'Verzija',
    language: 'Jezik',
    theme: 'Tema',
    darkMode: 'Tamni način',
    lightMode: 'Svijetli način',
    failedToLoad: 'Učitavanje podataka nije uspjelo',
    failedToSave: 'Spremanje nije uspjelo',
    failedToDelete: 'Brisanje nije uspjelo',
    failedToUpdate: 'Ažuriranje nije uspjelo',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovo?',
    confirmAction: 'Jeste li sigurni?',
    unsavedChanges: 'Imate nespremljene promjene. Jeste li sigurni da želite napustiti stranicu?',
    pageNotFound: '404 - Stranica nije pronađena',
    pageNotFoundDesc: 'Stranica koju tražite ne postoji.',
    backToDashboard: 'Natrag na nadzornu ploču',
    characters: 'znakovi',
    maxCharacters: 'Najviše {{max}} znakova',
    remaining: '{{count}} preostalo',
    selected: '{{count}} odabrano',
    of_total: '{{count}} od {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Zaglavlje, bočna traka, izbornici
  // ============================================================
  nav: {
    dashboard: 'Nadzorna ploča',
    requests: 'Zahtjevi',
    transports: 'Prijevozi',
    myPatients: 'Moji pacijenti',
    statistics: 'Statistika',
    flow: 'Tok',
    resources: 'Resources',
    exercise: 'Vježba',
    administration: 'Administracija',
    map: 'Karta',
    info: 'Informacije',
    users: 'Korisnici',
    assets: 'Sredstva',
    hubs: 'Čvorišta',
    treatmentFacilities: 'Zdravstvene ustanove',
    patientImport: 'Uvoz pacijenata',
    assetTemplates: 'Predlošci sredstava',
    dayTemplates: 'Dnevni predlošci',
    announcementTicker: 'Traka s obavijestima',
    exerciseStatistics: 'Statistika vježbe',
    settings: 'Postavke',
    auditLog: 'Revizijski zapis',
    exerciseControl: 'Upravljanje vježbom',
    dataSync: 'Sinkronizacija podataka',
    documentation: 'Dokumentacija',
    support: 'Podrška',
    about: 'O sustavu',
    assetContracts: 'Asset Contracts',
    notifications: 'Obavijesti',
    schedules: 'Rasporedi',
    capacityPlanning: 'Planiranje kapaciteta',
    transportPlanning: 'Planiranje prijevoza',
    transportBooking: 'Rezervacija prijevoza',
    flowDiagram: 'Dijagram toka',
    changePassword: 'Promijeni lozinku',
    missions: 'Misije',
    startPoints: 'Polazišne točke',
    hospital: 'Bolnica',
  },

  // ============================================================
  // AUTH — Prijava, lozinka, sesija
  // ============================================================
  auth: {
    login: 'Prijava',
    logout: 'Odjava',
    logoutNow: 'Odjavi se odmah',
    loggingIn: 'Prijavljivanje...',
    loginFailed: 'Prijava nije uspjela',
    email: 'E-pošta',
    password: 'Lozinka',
    username: 'Korisničko ime',
    enterEmail: 'Unesite svoju adresu e-pošte',
    enterPassword: 'Unesite svoju lozinku',
    enterUsername: 'Unesite svoje korisničko ime',
    forgotPassword: 'Zaboravili ste lozinku?',
    forgotPasswordTitle: 'Zaboravljena lozinka',
    forgotPasswordDesc: 'Unesite svoje korisničko ime i adresu e-pošte. Ako se oba podatka podudaraju, administratori će biti obaviješteni za poništavanje vaše lozinke.',
    requestPasswordReset: 'Zatraži poništavanje lozinke',
    sending: 'Slanje...',
    backToLogin: 'Natrag na prijavu',
    pleaseWait: 'Molimo pričekajte prije ponovnog pokušaja.',
    requestFailed: 'Zahtjev nije uspio',
    credentialsMatch: 'Ako se vjerodajnice podudaraju, administratori su obaviješteni.',
    forAccess: 'Za pristup se obratite svom administratoru sustava.',
    changePassword: 'Promijeni lozinku',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    passwordChanged: 'Lozinka je uspješno promijenjena',
    passwordMismatch: 'Lozinke se ne podudaraju',
    passwordTooShort: 'Lozinka mora imati najmanje 8 znakova',
    changingPassword: 'Mijenjanje...',
    mustChangePassword: 'Morate promijeniti lozinku prije nastavka.',
    sessionExpiring: 'Sesija istječe',
    sessionExpireText: 'Vaša sesija će isteći za <strong>{{time}}</strong>. Molimo spremite svoj rad i ponovno se prijavite.',
    dismiss: 'Odbaci',
    switchNation: 'Promijeni državu',
    returnTo: 'Vrati se na {{nation}}',
    viewingAs: 'Gledate kao',
    loggedInAs: 'prijavljeni kao {{nation}}',
    trainingMode: 'SAMO ZA POTREBE OBUKE',
    dedication: 'Stvoreno s ljubavlju i predanošću profesiji',
  },

  // ============================================================
  // ROLES — Korisničke uloge i oznake
  // ============================================================
  roles: {
    admin: 'Administrator sustava',
    excon: 'Voditelj vježbe',
    eu: 'Koordinator EU',
    planner: 'Planer',
    hub: 'Upravitelj čvorišta',
    nation: 'Država',
    readOnly: 'Samo za čitanje',
    systemAdmin: 'Administrator sustava',
    transportPlanner: 'Planer prijevoza',
    systemRoles: 'Sustavske uloge',
  },

  // ============================================================
  // STATUS — Stanja zahtjeva, ponuda, misija
  // ============================================================
  status: {
    draft: 'Nacrt',
    underReview: 'U pregledu',
    published: 'Objavljeno',
    underSelection: 'U odabiru',
    accepted: 'Prihvaćeno',
    planned: 'Planirano',
    inTransit: 'U prijevozu',
    completed: 'Završeno',
    closed: 'Zatvoreno',
    withdrawn: 'Povučeno',
    pending: 'Na čekanju',
    rejected: 'Odbijeno',
    cancelled: 'Otkazano',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    review: 'Pregled',
    selection: 'Odabir',
    transit: 'Prijevoz',
  },

  // ============================================================
  // CATEGORIES — Kategorije zahtjeva
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Osoblje',
    material: 'Materijal',
    equipment: 'Oprema',
    other: 'Ostalo',
    news: 'Vijesti',
  },

  // ============================================================
  // URGENCY — Razine hitnosti
  // ============================================================
  urgency: {
    routine: 'Redovna',
    priority: 'Prioritetna',
    urgent: 'Hitna',
    immediate: 'Trenutačna',
  },

  // ============================================================
  // ASSETS — Vrste prijevoznih sredstava
  // ============================================================
  assetTypes: {
    train: 'Vlak',
    ship: 'Brod',
    aircraft: 'Zrakoplov',
    bus: 'Autobus',
    ambulance: 'Hitna pomoć',
    drone: 'Dron',
    helicopter: 'Helikopter',
    ferry: 'Trajekt',
    other: 'Ostalo',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Nadzorna ploča',
    goodMorning: 'Dobro jutro',
    goodAfternoon: 'Dobar dan',
    goodEvening: 'Dobra večer',
    lastLogin: 'Zadnja prijava',
    infrastructure: 'Infrastruktura',
    transportAssets: 'Prijevozna sredstva',
    treatmentFacilities: 'Zdravstvene ustanove',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistika zahtjeva',
    viewAllRequests: 'Prikaži sve zahtjeve',
    availableAssets: 'Dostupna sredstva',
    seated: 'Sjedeći',
    lying: 'Ležeći',
    intensive: 'Intenzivni',
    notifications: 'Obavijesti',
    markAllRead: 'Označi sve kao pročitano',
    noNotifications: 'Još nema obavijesti',
    notifiedWhenActivity: 'Bit ćete obaviješteni kada dođe do nove aktivnosti',
    viewDetailsBtn: 'Prikaži pojedinosti',
    nationUsers: 'Korisnici države',
    user: 'Korisnik',
    roles: 'Uloge',
    noUsersFound: 'Nisu pronađeni korisnici',
    participatingNations: 'Sudjelujuće države',
    exerciseDisclaimer: 'Ovaj sustav namijenjen je samo za uporabu na vježbama. Unosite isključivo simulirane podatke vježbe. Radni tokovi prilagođeni su scenariju vježbe i mogu se razlikovati od stvarnih postupaka. Pravila IT sigurnosti i zaštite podataka ostaju u potpunosti na snazi.',
    notConfigured: 'Nije konfigurirano',
    requestCount: '{{count}} zahtjev(a)',
    clickToView: 'Kliknite za prikaz',
    systemAdministration: 'Administracija sustava',
    exerciseControlTitle: 'Upravljanje vježbom',
    euCoordination: 'Koordinacija EU',
    transportPlanningTitle: 'Planiranje prijevoza',
    hubManagement: 'Upravljanje čvorištima',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Novi zahtjev',
    myDrafts: 'Moji nacrti',
    pendingReview: 'Čeka pregled',
    activeTransports: 'Aktivni prijevozi',
    myPatients: 'Moji pacijenti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Zahtjevi',
    newRequest: 'Novi zahtjev',
    createRequest: 'Stvori zahtjev',
    editRequest: 'Uredi zahtjev',
    requestDetail: 'Pojedinosti zahtjeva',
    requestId: 'ID zahtjeva',
    fromNation: 'Od države',
    toNation: 'Za državu',
    requestingNation: 'Država podnositeljica',
    receivingNation: 'Država primateljica',
    category: 'Kategorija',
    urgency: 'Hitnost',
    status: 'Stanje',
    patients: 'Pacijenti',
    patientCount: 'Broj pacijenata',
    offers: 'Ponude',
    offerCount: 'Broj ponuda',
    created: 'Stvoreno',
    updated: 'Ažurirano',
    submittedBy: 'Podnio',
    reviewedBy: 'Pregledao',
    description: 'Opis',
    medicalDetails: 'Zdravstveni podaci',
    transportDetails: 'Podaci o prijevozu',
    additionalInfo: 'Dodatne informacije',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Točka polaska',
    arrivalPoint: 'Točka dolaska',
    estimatedDeparture: 'Predviđeni polazak',
    estimatedArrival: 'Predviđeni dolazak',
    submitForReview: 'Pošalji na pregled',
    publish: 'Objavi',
    startSelection: 'Započni odabir',
    acceptOffer: 'Prihvati ponudu',
    markInTransit: 'Označi kao u prijevozu',
    markCompleted: 'Označi kao završeno',
    closeRequest: 'Zatvori zahtjev',
    withdrawRequest: 'Povuci zahtjev',
    withdraw: 'Povuci',
    revertToDraft: 'Vrati u nacrt',
    deleteRequest: 'Obriši zahtjev',
    duplicateRequest: 'Dupliciraj zahtjev',
    createFollowUp: 'Stvori konsolidirani zahtjev',
    followUpRequest: 'Konsolidirani zahtjev',
    parentRequest: 'Izvorni zahtjev',
    childRequests: 'Konsolidirani zahtjevi',
    noRequests: 'Nisu pronađeni zahtjevi',
    noOffers: 'Još nema ponuda',
    addPatient: 'Dodaj pacijenta',
    removePatient: 'Ukloni pacijenta',
    patientDetails: 'Podaci o pacijentu',
    contactPerson: 'Kontakt osoba',
    contactPhone: 'Kontakt telefon',
    contactEmail: 'Kontakt e-pošta',
    specialRequirements: 'Posebni zahtjevi',
    medicalEquipment: 'Medicinska oprema',
    accompaniment: 'Pratnja',
    timeline: 'Vremenska crta',
    history: 'Povijest',
    addComment: 'Dodaj komentar',
    writeComment: 'Napišite komentar...',
    postComment: 'Objavi komentar',
    posting: 'Objavljuje se...',
    noComments: 'Još nema komentara',
    coverageBar: 'Pokrivenost',
    covered: 'pokriveno',
    uncovered: 'nepokriveno',
    filterByStatus: 'Filtriraj po stanju',
    filterByCategory: 'Filtriraj po kategoriji',
    filterByNation: 'Filtriraj po državi',
    searchRequests: 'Pretraži zahtjeve...',
    confirmWithdraw: 'Jeste li sigurni da želite povući ovaj zahtjev?',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovaj zahtjev?',
    confirmPublish: 'Jeste li sigurni da želite objaviti ovaj zahtjev? Bit će vidljiv svim državama.',
    confirmStartSelection: 'Jeste li sigurni da želite započeti odabir? Države će moći podnositi ponude.',
    warningStartSelection: 'Pokretanje odabira učinit će ovaj zahtjev vidljivim svim sudjelujućim državama. Moći će podnositi ponude za pacijente u ovom zahtjevu. Ova radnja se ne može poništiti.',
    warningMakeOffer: 'Podnošenjem ove ponude obvezujete svoju državu na pružanje predložene pomoći. Ova radnja će obavijestiti državu podnositeljicu i upravljanje vježbom.',
    saveDraft: 'Spremi nacrt',
    saving: 'Spremanje...',
    saveAndSubmit: 'Spremi i pošalji',
    step: 'Korak {{number}}',
    generalInfo: 'Opće informacije',
    patientInfo: 'Podaci o pacijentu',
    logisticsInfo: 'Logističke informacije',
    reviewSubmit: 'Pregled i slanje',
    requestTitle: 'Naslov zahtjeva',
    requestDescription: 'Opis zahtjeva',
    numberOfPatients: 'Broj pacijenata',
    typeOfAssistance: 'Vrsta pomoći',
    medicalTreatment: 'Liječenje',
    transportAssistance: 'Prijevozna pomoć',
    both: 'Oboje',
    treatmentOnly: 'Samo liječenje',
    transportOnly: 'Samo prijevoz',
    validationErrors: 'Molimo ispravite sljedeće pogreške:',
    fieldRequired: 'Ovo polje je obavezno',
    selectExitHub: 'Odaberite izlazno čvorište',
    createExitHub: 'Stvori izlazno čvorište',
    backToRequests: 'Natrag na zahtjeve',
    noRequestsFound: 'Nisu pronađeni zahtjevi',
    createFirstRequest: 'Stvorite svoj prvi zahtjev za početak',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ponude',
    createOffer: 'Stvori ponudu',
    makeOffer: 'Podnesi ponudu',
    manageOffers: 'Upravljaj ponudama',
    offerDetail: 'Pojedinosti ponude',
    offerId: 'ID ponude',
    offeringNation: 'Država ponuditeljica',
    offerType: 'Vrsta ponude',
    treatment: 'Liječenje',
    transport: 'Prijevoz',
    combined: 'Kombinirano',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ponuda liječenja',
    transportOffer: 'Ponuda prijevoza',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Odaberi pacijente',
    selectedPatients: 'Odabrani pacijenti',
    patientSelection: 'Odabir pacijenata',
    offerConfiguration: 'Konfiguracija ponude',
    reviewOffer: 'Pregledaj ponudu',
    submitOffer: 'Podnesi ponudu',
    submitting: 'Podnošenje...',
    acceptOffer: 'Prihvati ponudu',
    rejectOffer: 'Odbij ponudu',
    withdrawOffer: 'Povuci ponudu',
    noOffers: 'Nema dostupnih ponuda',
    noOffer: 'No Offer',
    offerStatus: 'Stanje ponude',
    offerDate: 'Datum ponude',
    transportAsset: 'Prijevozno sredstvo',
    departureDate: 'Datum polaska',
    arrivalDate: 'Datum dolaska',
    treatmentFacility: 'Zdravstvena ustanova',
    capacity: 'Kapacitet',
    availableCapacity: 'Dostupni kapacitet',
    totalCapacity: 'Ukupni kapacitet',
    selectAsset: 'Odaberi sredstvo',
    selectFacility: 'Odaberi ustanovu',
    offerNotes: 'Bilješke o ponudi',
    confirmAccept: 'Jeste li sigurni da želite prihvatiti ovu ponudu?',
    confirmReject: 'Jeste li sigurni da želite odbiti ovu ponudu?',
    extendTransport: 'Produži prijevoz',
    transportExtension: 'Produženje prijevoza',
    comparisonView: 'Usporedni prikaz',
    shortlist: 'Uži izbor',
    addToShortlist: 'Dodaj u uži izbor',
    removeFromShortlist: 'Ukloni iz užeg izbora',
    leaveConfirmTitle: 'Napustiti ovu stranicu?',
    leaveConfirmMessage: 'Imate nespremljene promjene. Jeste li sigurni da želite napustiti stranicu?',
    stayOnPage: 'Ostani na stranici',
    leavePage: 'Napusti stranicu',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Prijevozi',
    missionDetail: 'Pojedinosti prijevoza',
    missionId: 'ID prijevoza',
    missionStatus: 'Stanje prijevoza',
    createMission: 'Stvori prijevoz',
    overview: 'Pregled',
    patientsTab: 'Pacijenti',
    transportsTab: 'Dionice prijevoza',
    treatmentTab: 'Liječenje',
    reviewTab: 'Pregled',
    departure: 'Polazak',
    arrival: 'Dolazak',
    origin: 'Polazište',
    destination: 'Odredište',
    stops: 'Stanice',
    addStop: 'Dodaj stanicu',
    removeStop: 'Ukloni stanicu',
    stopName: 'Naziv stanice',
    stopType: 'Vrsta stanice',
    estimatedTime: 'Predviđeno vrijeme',
    actualTime: 'Stvarno vrijeme',
    asset: 'Sredstvo',
    driver: 'Vozač',
    crew: 'Posada',
    noMissions: 'Nisu pronađeni prijevozi',
    completeMission: 'Završi prijevoz',
    cancelMission: 'Otkaži prijevoz',
    startTransport: 'Započni prijevoz',
    missionChain: 'Lanac prijevoza',
    linkedMissions: 'Povezani prijevozi',
    handover: 'Primopredaja',
    handoverPoint: 'Točka primopredaje',
    pickupPoint: 'Točka preuzimanja',
    dropoffPoint: 'Točka iskrcaja',
    searchTransports: 'Pretraži prijevoze...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacijenti',
    myPatients: 'Moji pacijenti',
    patientId: 'ID pacijenta',
    firstName: 'Ime',
    lastName: 'Prezime',
    dateOfBirth: 'Datum rođenja',
    age: 'Dob',
    gender: 'Spol',
    male: 'Muški',
    female: 'Ženski',
    other: 'Ostalo',
    nationality: 'Državljanstvo',
    diagnosis: 'Dijagnoza',
    condition: 'Stanje',
    stable: 'Stabilno',
    critical: 'Kritično',
    serious: 'Ozbiljno',
    treatmentNeeded: 'Potrebno liječenje',
    allergies: 'Alergije',
    medications: 'Lijekovi',
    bloodType: 'Krvna grupa',
    weight: 'Težina (kg)',
    infectious: 'Zarazan',
    mentalHealth: 'Mentalno zdravlje',
    mobility: 'Pokretnost',
    ambulatory: 'Pokretan',
    wheelchair: 'Invalidska kolica',
    stretcher: 'Nosila',
    intensive: 'Intenzivna njega',
    oxygenRequired: 'Potreban kisik',
    ventilator: 'Ventilator',
    medicalEscort: 'Medicinska pratnja',
    noPatients: 'Nisu pronađeni pacijenti',
    patientDetails: 'Podaci o pacijentu',
    medicalHistory: 'Medicinska povijest',
    travelDocuments: 'Putne isprave',
    passport: 'Putovnica',
    pseudonymizedId: 'Pseudonimizirani ID',
    sensitiveData: 'Osjetljivi podaci',
    journey: 'Put pacijenta',
    assignedTo: 'Dodijeljen',
    currentLocation: 'Trenutna lokacija',
    importPatients: 'Uvezi pacijente',
    exportPatients: 'Izvezi pacijente',
    seated: 'Sjedeći',
    lying: 'Ležeći',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Korisnici',
    createUser: 'Stvori korisnika',
    editUser: 'Uredi korisnika',
    deleteUser: 'Obriši korisnika',
    username: 'Korisničko ime',
    displayName: 'Prikazno ime',
    email: 'E-pošta',
    password: 'Lozinka',
    role: 'Uloga',
    roles: 'Uloge',
    nation: 'Država',
    active: 'Aktivno',
    lastLogin: 'Zadnja prijava',
    createdAt: 'Stvoreno',
    isNation: 'Država',
    isEU: 'EU',
    isAdmin: 'Administrator',
    isExcon: 'EXCON',
    isPlanner: 'Planer',
    isHub: 'Čvorište',
    isReadOnly: 'Samo za čitanje',
    noUsers: 'Nisu pronađeni korisnici',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovog korisnika?',
    resetPassword: 'Poništi lozinku',
    generatePassword: 'Generiraj lozinku',
    searchUsers: 'Pretraži korisnike...',
    userCreated: 'Korisnik je uspješno stvoren',
    userUpdated: 'Korisnik je uspješno ažuriran',
    userDeleted: 'Korisnik je uspješno obrisan',
    selectNation: 'Odaberite državu',
    mustChangePassword: 'Mora promijeniti lozinku pri sljedećoj prijavi',
    flagImage: 'Slika zastave',
    exportUsers: 'Izvezi korisnike',
    importUsers: 'Uvezi korisnike',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Sredstva',
    createAsset: 'Stvori sredstvo',
    editAsset: 'Uredi sredstvo',
    deleteAsset: 'Obriši sredstvo',
    assetName: 'Naziv sredstva',
    assetType: 'Vrsta sredstva',
    capacitySeated: 'Kapacitet (sjedeći)',
    capacityLying: 'Kapacitet (ležeći)',
    capacityIntensive: 'Kapacitet (intenzivni)',
    owner: 'Vlasnik',
    operator: 'Operater',
    baseLocation: 'Osnovna lokacija',
    range: 'Domet',
    speed: 'Brzina',
    noAssets: 'Nisu pronađena sredstva',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovo sredstvo?',
    searchAssets: 'Pretraži sredstva...',
    assetCreated: 'Sredstvo je uspješno stvoreno',
    assetUpdated: 'Sredstvo je uspješno ažurirano',
    assetDeleted: 'Sredstvo je uspješno obrisano',
    exportAssets: 'Izvezi sredstva',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Čvorišta',
    startPoints: 'Polazišne točke',
    createHub: 'Stvori čvorište',
    editHub: 'Uredi čvorište',
    deleteHub: 'Obriši čvorište',
    hubName: 'Naziv čvorišta',
    hubType: 'Vrsta čvorišta',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Ulazno čvorište',
    airport: 'Zračna luka',
    seaport: 'Morska luka',
    railStation: 'Željeznička stanica',
    roadPoint: 'Cestovna točka',
    ucpmClassification: 'Klasifikacija UCPM',
    icaoCode: 'Kôd ICAO',
    iataCode: 'Kôd IATA',
    noHubs: 'Nisu pronađena čvorišta',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovo čvorište?',
    searchHubs: 'Pretraži čvorišta...',
    nationAssignment: 'Dodjela država',
    assignNations: 'Dodijeli države',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Zdravstvene ustanove',
    createFacility: 'Stvori ustanovu',
    editFacility: 'Uredi ustanovu',
    deleteFacility: 'Obriši ustanovu',
    facilityName: 'Naziv ustanove',
    facilityType: 'Vrsta ustanove',
    hospitalName: 'Naziv bolnice',
    bedCapacity: 'Kapacitet kreveta',
    specialties: 'Specijalnosti',
    availableBeds: 'Dostupni kreveti',
    totalBeds: 'Ukupni broj kreveta',
    contactPerson: 'Kontakt osoba',
    noFacilities: 'Nisu pronađene zdravstvene ustanove',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovu ustanovu?',
    searchFacilities: 'Pretraži ustanove...',
    hubNationAssignment: 'Dodjela država čvorištu',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Rasporedi',
    createSchedule: 'Stvori raspored',
    editSchedule: 'Uredi raspored',
    deleteSchedule: 'Obriši raspored',
    scheduleName: 'Naziv rasporeda',
    scheduleType: 'Vrsta rasporeda',
    recurring: 'Ponavljajući',
    oneTime: 'Jednokratni',
    frequency: 'Učestalost',
    daily: 'Dnevno',
    weekly: 'Tjedno',
    startDate: 'Datum početka',
    endDate: 'Datum završetka',
    departureTime: 'Vrijeme polaska',
    arrivalTime: 'Vrijeme dolaska',
    stops: 'Stanice',
    addStop: 'Dodaj stanicu',
    noSchedules: 'Nisu pronađeni rasporedi',
    bookings: 'Rezervacije',
    timeline: 'Vremenska crta',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Obavijesti',
    markAllRead: 'Označi sve kao pročitano',
    markAsRead: 'Označi kao pročitano',
    markAsUnread: 'Označi kao nepročitano',
    noNotifications: 'Nema obavijesti',
    viewAll: 'Prikaži sve obavijesti',
    settings: 'Postavke obavijesti',
    emailNotifications: 'Obavijesti e-poštom',
    inAppNotifications: 'Obavijesti u aplikaciji',
    notifyOn: 'Obavijesti me o',
    requestCreated: 'Novi zahtjev',
    requestPublished: 'Zahtjev objavljen',
    requestClosed: 'Zahtjev zatvoren',
    requestCompleted: 'Zahtjev završen',
    commentAdded: 'Novi komentar',
    offerReceived: 'Ponuda primljena',
    offerAccepted: 'Ponuda prihvaćena',
    statusChanged: 'Stanje promijenjeno',
    selectionStarted: 'Odabir započet',
    missionCreated: 'Prijevoz stvoren',
    missionStatusUpdated: 'Prijevoz ažuriran',
    transportPartnerNamed: 'Prijevozni partner',
    transportExtensionReceived: 'Produženje prijevoza',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Postavke',
    general: 'Opće',
    system: 'Sustav',
    email: 'E-pošta',
    sync: 'Sinkronizacija',
    security: 'Sigurnost',
    appearance: 'Izgled',
    systemName: 'Naziv sustava',
    systemEmail: 'Sustavska e-pošta',
    maintenanceMode: 'Način održavanja',
    readOnlyMode: 'Način samo za čitanje',
    emailEnabled: 'E-pošta omogućena',
    smtpHost: 'SMTP poslužitelj',
    smtpPort: 'SMTP priključak',
    smtpUser: 'SMTP korisnik',
    smtpPassword: 'SMTP lozinka',
    senderEmail: 'E-pošta pošiljatelja',
    senderName: 'Ime pošiljatelja',
    testEmail: 'Pošalji testnu e-poštu',
    syncEnabled: 'Sinkronizacija omogućena',
    syncUrl: 'URL sinkronizacije',
    syncApiKey: 'API ključ sinkronizacije',
    settingsSaved: 'Postavke su uspješno spremljene',
    helpdesk: 'Služba za pomoć',
    helpdeskTitle: 'Naslov službe za pomoć',
    helpdeskEmail: 'E-pošta službe za pomoć',
    helpdeskPhone: 'Telefon službe za pomoć',
    helpdeskInfo: 'Informacije o službi za pomoć',
    realLifeSupport: 'Podrška u stvarnom životu',
    trainingMode: 'Način obuke',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Revizijski zapis',
    action: 'Radnja',
    user: 'Korisnik',
    target: 'Cilj',
    details: 'Pojedinosti',
    timestamp: 'Vremenski žig',
    ipAddress: 'IP adresa',
    noLogs: 'Nisu pronađeni revizijski zapisi',
    searchLogs: 'Pretraži zapise...',
    filterByAction: 'Filtriraj po radnji',
    filterByUser: 'Filtriraj po korisniku',
    exportLogs: 'Izvezi zapise',
    exportCsv: 'Izvezi CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Upravljanje vježbom',
    currentDay: 'Trenutni dan',
    exerciseDay: 'Dan vježbe',
    nextDay: 'Sljedeći dan',
    previousDay: 'Prethodni dan',
    resetExercise: 'Poništi vježbu',
    startExercise: 'Započni vježbu',
    endExercise: 'Završi vježbu',
    dayReset: 'Poništavanje dana',
    confirmReset: 'Jeste li sigurni da želite poništiti dan vježbe? Time ćete obrisati sve podatke za trenutni dan.',
    resetInProgress: 'Poništavanje u tijeku...',
    maintenanceMode: 'Način održavanja',
    enableMaintenance: 'Omogući održavanje',
    disableMaintenance: 'Onemogući održavanje',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sinkronizacija podataka',
    syncStatus: 'Stanje sinkronizacije',
    lastSync: 'Zadnja sinkronizacija',
    pendingItems: 'Stavke na čekanju',
    syncNow: 'Sinkroniziraj sada',
    syncing: 'Sinkronizacija...',
    syncSuccess: 'Sinkronizacija je uspješno završena',
    syncFailed: 'Sinkronizacija nije uspjela',
    outbox: 'Odlazni spremnik',
    inbox: 'Dolazni spremnik',
    configuration: 'Konfiguracija',
    targetUrl: 'Odredišni URL',
    apiKey: 'API ključ',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Karta',
    layers: 'Slojevi',
    requests: 'Zahtjevi',
    hubs: 'Čvorišta',
    facilities: 'Ustanove',
    routes: 'Rute',
    showAll: 'Prikaži sve',
    hideAll: 'Sakrij sve',
    zoomIn: 'Približi',
    zoomOut: 'Udalji',
    resetView: 'Poništi prikaz',
    satellite: 'Satelitski',
    terrain: 'Teren',
    offline: 'Izvan mreže',
    online: 'Na mreži',
    tilesOffline: 'Pločice karte posluže se lokalno',
    tilesOnline: 'Pločice karte učitavaju se s mrežnih poslužitelja',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Pregled',
    requestsByStatus: 'Zahtjevi po stanju',
    requestsByCategory: 'Zahtjevi po kategoriji',
    requestsByNation: 'Zahtjevi po državi',
    offersByStatus: 'Ponude po stanju',
    patientsByCondition: 'Pacijenti po stanju',
    transportsByStatus: 'Prijevozi po stanju',
    timeline: 'Vremenska crta',
    totalRequests: 'Ukupni broj zahtjeva',
    totalOffers: 'Ukupni broj ponuda',
    totalPatients: 'Ukupni broj pacijenata',
    totalTransports: 'Ukupni broj prijevoza',
    averageResponseTime: 'Prosječno vrijeme odgovora',
    completionRate: 'Stopa završenosti',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistika vježbe',
    overview: 'Pregled',
    byCategory: 'Po kategoriji',
    byNation: 'Po državi',
    byDay: 'Po danu',
    totalPatientsMoved: 'Ukupni broj prevezenih pacijenata',
    totalRequestsProcessed: 'Ukupni broj obrađenih zahtjeva',
    averageProcessingTime: 'Prosječno vrijeme obrade',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Dijagram toka',
    sankey: 'Sankey',
    nodeGraph: 'Čvorišni graf',
    refresh: 'Osvježi',
    noData: 'Nema dostupnih podataka o toku',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'O sustavu',
    version: 'Verzija',
    systemInfo: 'Informacije o sustavu',
    buildDate: 'Datum izgradnje',
    environment: 'Okruženje',
    description: 'ARCOS — Napredni sustav za komunikaciju zahtjeva',
    subtitle: 'Pomoć stradalima i medicinske operacije',
    whatIsArcos: 'Što je ARCOS? – Objašnjenje za sudionike vježbe',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Uz podršku MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – gdje znatiželja susreće suradnju.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentacija',
    gettingStarted: 'Početak rada',
    userGuide: 'Korisnički priručnik',
    faq: 'Česta pitanja',
    troubleshooting: 'Otklanjanje poteškoća',
    apiReference: 'API referenca',
    downloadTemplate: 'Preuzmi predložak',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Uvoz pacijenata',
    uploadFile: 'Učitaj datoteku',
    selectFile: 'Odaberi datoteku',
    preview: 'Pretpregled',
    importNow: 'Uvezi sada',
    importing: 'Uvoženje...',
    importSuccess: '{{count}} pacijenata uspješno uvezeno',
    importFailed: 'Uvoz nije uspio',
    downloadTemplate: 'Preuzmi predložak',
    dragDrop: 'Povucite i ispustite datoteku ovdje ili kliknite za odabir',
    supportedFormats: 'Podržani formati: XLSX, XLS, CSV',
    rowsFound: '{{count}} pronađenih redova',
    validRows: '{{count}} valjanih redova',
    invalidRows: '{{count}} nevaljanih redova',
    duplicateRows: '{{count}} dupliciranih redova',
    previewData: 'Pretpregled podataka',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planiranje prijevoza',
    planRoute: 'Planiraj rutu',
    routeBuilder: 'Graditelj rute',
    addWaypoint: 'Dodaj međutočku',
    removeWaypoint: 'Ukloni međutočku',
    estimatedDuration: 'Predviđeno trajanje',
    distance: 'Udaljenost',
    selectVehicle: 'Odaberi vozilo',
  },

  transportBooking: {
    title: 'Rezervacija prijevoza',
    bookTransport: 'Rezerviraj prijevoz',
    availableSlots: 'Dostupni termini',
    bookingConfirmed: 'Rezervacija potvrđena',
    cancelBooking: 'Otkaži rezervaciju',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planiranje kapaciteta',
    totalCapacity: 'Ukupni kapacitet',
    usedCapacity: 'Iskorišteni kapacitet',
    availableCapacity: 'Dostupni kapacitet',
    utilizationRate: 'Stopa iskorištenosti',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Predlošci sredstava',
    dayTemplates: 'Dnevni predlošci',
    createTemplate: 'Stvori predložak',
    editTemplate: 'Uredi predložak',
    deleteTemplate: 'Obriši predložak',
    templateName: 'Naziv predloška',
    applyTemplate: 'Primijeni predložak',
    noTemplates: 'Nisu pronađeni predlošci',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovaj predložak?',
    confirmApply: 'Jeste li sigurni da želite primijeniti ovaj predložak? Time ćete prebrisati postojeće podatke.',
    exportTemplates: 'Izvezi predloške',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Traka s obavijestima',
    createAnnouncement: 'Stvori obavijest',
    editAnnouncement: 'Uredi obavijest',
    deleteAnnouncement: 'Obriši obavijest',
    message: 'Poruka',
    startTime: 'Vrijeme početka',
    endTime: 'Vrijeme završetka',
    active: 'Aktivno',
    noAnnouncements: 'Nema obavijesti',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovu obavijest?',
  },

  // ============================================================
  // COMPONENTS — Nizovi ponovljivih komponenti
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Pretraži...',
      noResults: 'Nema rezultata',
      showing: 'Prikazano {{from}} do {{to}} od {{total}}',
      rowsPerPage: 'Redova po stranici',
      previousPage: 'Prethodna stranica',
      nextPage: 'Sljedeća stranica',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Potvrdi',
      cancel: 'Odustani',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Nespremljene promjene',
      message: 'Imate nespremljene promjene. Jeste li sigurni da želite napustiti ovu stranicu?',
      stay: 'Ostani na stranici',
      leave: 'Napusti stranicu',
    },
    // EmptyState
    emptyState: {
      noData: 'Nema dostupnih podataka',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Nešto je pošlo krivo',
      message: 'Došlo je do neočekivane pogreške. Molimo pokušajte osvježiti stranicu.',
      retry: 'Pokušaj ponovo',
    },
    // ExportButton
    exportButton: {
      export: 'Izvezi',
      exporting: 'Izvoženje...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Ispiši',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Nacrt',
      review: 'Pregled',
      published: 'Objavljeno',
      selection: 'Odabir',
      inTransit: 'U prijevozu',
      completed: 'Završeno',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Mrežna instanca',
      message: 'Način samo za čitanje. Podaci se sinkroniziraju s primarnog poslužitelja.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Gledate kao',
      loggedInAs: 'prijavljeni kao {{nation}}',
      returnTo: 'Vrati se na {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Pretraži stranice, zahtjeve, prijevoze...',
      searching: 'Pretraživanje...',
      noResults: 'Nema rezultata za "{{query}}"',
      navigate: 'Navigiraj',
      select: 'Odaberi',
      close: 'Zatvori',
      pages: {
        dashboard: 'Nadzorna ploča',
        requests: 'Zahtjevi',
        transports: 'Prijevozi',
        map: 'Karta',
        myPatients: 'Moji pacijenti',
        flowDiagram: 'Dijagram toka',
        statistics: 'Statistika',
        assets: 'Sredstva',
        startPoints: 'Polazišne točke / Čvorišta',
        treatmentFacilities: 'Zdravstvene ustanove',
        users: 'Korisnici',
        settings: 'Postavke',
        auditLogs: 'Revizijski zapis',
        exerciseControl: 'Upravljanje vježbom',
        dataSync: 'Sinkronizacija podataka',
        patientImport: 'Uvoz pacijenata',
        notifications: 'Obavijesti',
        documentation: 'Dokumentacija',
      },
      actions: {
        importPatientsJson: 'Uvezi Pacijenata (JSON)',
        importPatientsExcel: 'Uvezi Pacijenata (Excel)',
        importUsers: 'Uvezi Korisnika (Excel)',
        importAssetTemplates: 'Uvezi Predloške imovine (Excel)',
        importDayTemplates: 'Uvezi Unose dnevnog predloška (Excel)',
        exportRequests: 'Izvezi Zahtjeva (Excel)',
        exportPatients: 'Izvezi Pacijenata (Excel)',
        exportUsers: 'Izvezi Korisnika (Excel)',
        exportCredentials: 'Izvezi Vjerodajnice (PDF)',
        exportAuditExcel: 'Izvezi Revizijski zapisnik (Excel)',
        exportAuditPdf: 'Izvezi Revizijski zapisnik (PDF)',
        pagePatientImport: 'Stranica uvoza pacijenata',
        pageRequestDetail: 'Stranica detalja zahtjeva',
        pageUsers: 'Stranica upravljanja korisnicima',
        pageAssetTemplates: 'Stranica predložaka imovine',
        pageDayTemplates: 'Stranica dnevnih predložaka',
        pageRequests: 'Stranica popisa zahtjeva',
        pageAuditLogs: 'Stranica revizijskog zapisnika',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesija istječe',
      message: 'Vaša sesija će isteći za <strong>{{time}}</strong>. Molimo spremite svoj rad i ponovno se prijavite.',
      dismiss: 'Odbaci',
      logoutNow: 'Odjavi se odmah',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Odaberite 4 vremenske zone',
      configure: 'Konfiguriraj vremenske zone',
      reset: 'Poništi',
      apply: 'Primijeni',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Odaberi lokaciju',
      latitude: 'Zemljopisna širina',
      longitude: 'Zemljopisna dužina',
      clickToSelect: 'Kliknite na kartu za odabir lokacije',
    },
    // Modal
    modal: {
      close: 'Zatvori',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Početna',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Održavanje sustava',
    message: 'Sustav se poništava za sljedeći dan vježbe. Molimo pričekajte dok se postupak ne završi.',
    autoRefresh: 'Ova stranica će se automatski osvježiti kada sustav ponovno bude dostupan.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Najmanje 10 znakova',
    uppercase: '1 veliko slovo',
    lowercase: '1 malo slovo',
    digit: '1 znamenka',
    special: '1 posebni znak',
  },
};

export default hr;
